import { Typography } from '@mui/material';

import dompurify from 'dompurify';

import { AccordionAppearance, useAccordion } from 'components';

import { ModalProps } from 'components/Modal/types';

import { useTranslation } from 'react-i18next';

import { HowItWorksModalStyles } from './HowItWorksModal.styles';

const sanitizer = dompurify.sanitize;

type HowItWorksModalProps = {
  Modal: ({ content, render }: ModalProps) => JSX.Element;
};

export const HowItWorksModal = ({ Modal }: HowItWorksModalProps) => {
  const { t }: any = useTranslation();
  const accordionList = useAccordion(t('homePage:howItWorks:list', { returnObjects: true }), AccordionAppearance.DARK);
  const descriptionContent = t('homePage:howItWorks:description', { returnObjects: true }).map((content: string) => (
    <Typography
      key={content.slice(0, 15)}
      color='common.black'
      dangerouslySetInnerHTML={{
        __html: sanitizer(content),
      }}
      variant='body2'
    />
  ));

  return (
    <Modal
      slug={t('homePage:howItWorks:slug')}
      content={[
        descriptionContent,
        <HowItWorksModalStyles.List key='content' id='how-it-works-list'>
          {accordionList}
        </HowItWorksModalStyles.List>,
      ]}
      render={({ closeButton, content }) => (
        <>
          <HowItWorksModalStyles.Header>
            <Typography color='primary.light' variant='h6'>
              {t('homePage:howItWorks:title')}
            </Typography>
            {closeButton}
          </HowItWorksModalStyles.Header>
          {content}
        </>
      )}
    />
  );
};
